import React from "react";

const ConferenceTalk = () => {
  return (
    <div className="textAlign">
      <div className="mb-1">
        <b>Atanu K Metya</b> and Valeria Molinero&nbsp;
        <font color="118D76">
          "Mechanisms of Ice Nucleation on Organic Crystal" (Poster).
        </font>
        &nbsp;The Gordon Research Conference on Chemistry and Physics of
        Liquids, August 04-09, 2019, Holderness School in Holderness, NH United
        States.
      </div>
      <br />
      <div className="mb-1">
        <b>Atanu K Metya</b> and Jayant K Singh&nbsp;
        <font color="118D76">
          "Freezing of supercooled aqueous salt solutions on surfaces" (Poster).
        </font>
        &nbsp;RARE, December 07-10, 2017, Jaypee Palace Hotels & Convention
        Centre, Agra, India
      </div>
      <br />
      <div className="mb-1">
        Atanu K Metya, <b>Jayant K Singh</b> and Florian Müller-Plathe&nbsp;
        <font color="118D76">
          "Ice nucleation on nano-textured surfaces: Influence of surface
          fraction, pillar height and wetting states" (Talk).
        </font>
        &nbsp;ICMS, October 23-26, 2017, Shanghai, China.
      </div>
      <br />
      <div className="mb-1">
        Atanu K Metya and <b>Jayant K Singh</b>&nbsp;
        <font color="118D76">
          "Nucleation of aqueous salt solutions on solid surfaces" (Talk).
        </font>
        &nbsp;Thermodynamics September 05-08, 2017, Edinburgh, UK.
      </div>
      <br />
      <div className="mb-1">
        Atanu K Metya and <b>Jayant K Singh</b>&nbsp;
        <font color="118D76">
          "Ice nucleation on nanotextured surfaces: influence of surface
          fraction, pillar height and wetting states" (Talk).
        </font>
        &nbsp;WaterSpain, July 06-07, 2017, Zaragoza, Spain.
      </div>
      <br />
      <div className="mb-1">
        <b>Atanu K Metya </b>, Sandip Khan and Jayant K Singh&nbsp;
        <font color="118D76">
          "Transition of ethanol–water droplet on smooth and pillared surfaces:
          A molecular dynamic study" (Talk).
        </font>
        &nbsp;AIChE Annual Meeting, November 3, 2013, San Francisco, CA, USA.
      </div>
      <br />
      <div className="mb-1">
        <b>Utsav Kumar </b>, Atanu K Metya and Jayant K Singh&nbsp;
        <font color="118D76">
          "Study of transport properties and stress analysis using macro and
          atomistic simulations for lithium based rechargeable batteries"
          (Talk).
        </font>
        &nbsp;AIChE, October 31, 2012, Pittsburg, USA.
      </div>
    </div>
  );
};

export default ConferenceTalk;
